import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { ref, uploadBytes, listAll, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/firebase.config';

export default function Home1() {
  const [uploader, setUploader] = useState(null);
  const [getList, setGetList] = useState([]);

  const handleSubmit = () => {
    if (!uploader) return;

    let random = Math.floor(Math.random() * 100 + 1);
    const imageRef = ref(storage, `images/${uploader.name + random}`);
    uploadBytes(imageRef, uploader)
      .then((snaphsort) => {
        // alert('Image Uploaded');
        getDownloadURL(snaphsort.ref)
          .then((url) => {
            setGetList((prevImage) => [...prevImage, url]);
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      })
      .catch((error) => {
        throw new Error(error.message);
      });
  };
  ////////////////////////////////////////////

  useEffect(() => {
    const getRef = ref(storage, 'images/');
    listAll(getRef)
      .then((res) => {
        res.items.forEach((item) => {
          getDownloadURL(item)
            .then((url) => {
              setGetList((prev) => [...prev, url]);
            })
            .catch((error) => {
              throw new Error(error.message);
            });
        });
      })
      .catch((error) => {
        throw new Error(error.message);
      });
  }, []);

  ////////////////////////////////////////////
  return (
    <div className='container mt-4'>
      <Form.Group controlId='formFileLg' className='mb-3'>
        <Form.Label>Upload :) Image / File</Form.Label>
        <Form.Control type='file' onChange={(e) => setUploader(e.target.files[0])} />
      </Form.Group>
      <Button variant='primary' onClick={handleSubmit}>
        Submit
      </Button>
      <div className='container text-center mt-3'>
        {getList.length === 0 ? (
          <p className=' p-2 m-2 border bg-dark text-white'>we don't have an image/file please uplod.</p>
        ) : (
          getList.map((url, index) => {
            return (
              <div className='p-2 m-2 border' key={index}>
                <img src={url} alt='' width={400} height={400} />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
